export default "__VITE_PUBLIC_ASSET__267a0439__"